import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { ScalableDialog } from "src/libs/useful"
import { MAP_DIALOG_MODE } from "src/libs/yandexMap"
import { MAP_FILTER } from "../../data/interfaces"
import EventContent from "../components/EventContent"
import PlaceContent from "../components/PlaceContent"
import TeamContent from "../components/TeamContent"
import EventCluster from "./EventCluster"
import PlaceCluster from "./PlaceCluster"
import TeamCluster from "./TeamCluster"

interface IMapDialogProps {
    isOpen: boolean
    type: MAP_FILTER
    mode: MAP_DIALOG_MODE
    data: any
    size: DIALOG_SIZE
    onClose: () => void
    onOpenLogin?: () => void
}
const MapDialog = (props: IMapDialogProps): JSX.Element => {
  return <ScalableDialog
    isOpen={props.isOpen} 
    portalContainer={document.getElementById("modal-root")!}
    onClose={props.onClose}
    dialogSize={props.size}
    hideClose={false}
    mayFullScreen={true}
  >
    <div className=" h-100">
        <DialogContent 
          type={props.type}  
          mode={props.mode} 
          data={props.data} 
          onClose={props.onClose} 
          onOpenLogin={props.onOpenLogin}
        />
    </div>
  </ScalableDialog>
} 

export default MapDialog

const DialogContent = ({ type, mode, data, onClose, onOpenLogin }:any) : JSX.Element => {
    switch(mode) {
        case MAP_DIALOG_MODE.MARKER_DATA:
            switch(type) {
              case MAP_FILTER.TEAM:
                return <TeamContent item={ data } onClose={ onClose } onOpenLogin={onOpenLogin}/>
              case MAP_FILTER.EVENTS:
                return <EventContent item={ data } onClose={ onClose } onOpenLogin={onOpenLogin}/>
              case MAP_FILTER.PLACES:
              default:
                return <PlaceContent item={ data } onClose={ onClose } onOpenLogin={onOpenLogin}/>
            }
        case MAP_DIALOG_MODE.CLUSTER_DATA:
          switch(type) {
            case MAP_FILTER.TEAM:
              return <TeamCluster items={ data } onClose={ onClose } onOpenLogin={onOpenLogin}/>
            case MAP_FILTER.EVENTS:
              return <EventCluster items={ data } onClose={ onClose } onOpenLogin={onOpenLogin}/>
            case MAP_FILTER.PLACES:
            default:
              return <PlaceCluster items={ data } onClose={ onClose } onOpenLogin={onOpenLogin}/>
          }    
        case MAP_DIALOG_MODE.NONE:
        default:
            return <div>NONE</div>
    }
}